import React, { useEffect, useRef, useState } from "react";

import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TableBody,
  TextField,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import dayjs from "dayjs";
import { ThreeCircles } from "react-loader-spinner";

import SideNav from "component/layouts/sideNav";
import {
  customerCategoryCellRenderer,
  getItemCategories,
  getItems,
  getSiteCategories,
  getSites,
  getSupplierCategories,
  getSuppliers,
  globalFilter,
  itemCategoryCellRenderer,
  itemCellRenderer,
  setItemCategories,
  setItems,
  setSiteCategories,
  setSites,
  setSupplierCategories,
  setSuppliers,
  siteCellRenderer,
  supplierCategoryCellRenderer,
  supplierCellRenderer,
} from "component/cellRenderers/renderers";
import { setAlertTitleText } from "component/modal/alertModal";

import {
  LIGHT_GREY_BACKGROUND,
  SPANISH_GREEN,
  WHITE,
} from "resources/constant/colors/theme";
import {
  EXPORT,
  GENERATE,
  GOODS_RECEIVED_REPORT,
  MATERIAL_MANAGEMENT_REPORT,
} from "resources/constant/strings/string";
import { PATH_GOODS_RECEIVED_REPORT } from "resources/constant/url/url";

import { APIMASTER } from "apihandler/master";
import { APIREPORTS } from "apihandler/reports";
import { APIUTILS } from "apihandler/utils";

const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  color: SPANISH_GREEN,
  transform: "translate(-50%, -50%)",
  zIndex: 2,
};

export default function GoodsReceivedReport() {
  const [itemDetails, setItemDetails] = useState([]);
  const [dataReady, setDataReady] = useState(true);

  const getSortedDataFromGrid = () => {
    const sortedData = [];
    gridRef1.current.api.forEachNodeAfterFilterAndSort((node) => {
      sortedData.push(node.data);
    });
    return sortedData;
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    validation();
  };

  function validation() {
    setDataReady(false);
    if (dto.isBillable === 2) dto.isBillable = null;
    const payload = { ...dto };
    if (groupBy !== "none") payload.groupBy = groupBy;
    APIREPORTS.GoodsReceivedReport(payload)
      .then((response) => response.json())
      .then((data) => {
        if (data.statusCode !== 200) {
          setDataReady(true);
          setAlertTitleText("Oops..", `An error occurred ${data.message}`);
          return;
        }

        try {
          setDataReady(true);
          gridRef1.current.api.setRowData([]);
        } catch (e) {}

        data.response.itemDetails.forEach((x) => {
          const reqdItem = items.filter((y) => y.value === x.itemId);
          x.itemCategoryId =
            reqdItem.length > 0 ? reqdItem[0].dependentvalue : null;
          const reqdItemCategory = itemCategories.filter(
            (y) => y.value === x.itemCategoryId
          );
          x.itemCategory =
            reqdItemCategory.length > 0 ? reqdItemCategory[0].name : "";
          x.item = reqdItem.length > 0 ? reqdItem[0].name : "";
          const reqdSite = sites.filter((y) => y.value === x.customerId);
          x.siteCategoryId =
            reqdSite.length > 0 ? reqdSite[0].dependentvalue : null;
          const reqdSiteCategory = siteCategoryItems.filter(
            (y) => y.value === x.siteCategoryId
          );
          x.siteCategory =
            reqdSiteCategory.length > 0 ? reqdSiteCategory[0].name : "";
          x.site = reqdSite.length > 0 ? reqdSite[0].name : "";
          const reqdSupplier = suppliers.filter(
            (y) => y.value === x.supplierId
          );
          x.supplierCategoryId =
            reqdSupplier.length > 0 ? reqdSupplier[0].dependentvalue : null;
          const reqdSupplierCategory = supplierCategoryItems.filter(
            (y) => y.value === x.supplierCategoryId
          );
          x.supplierCategory =
            reqdSupplierCategory.length > 0 ? reqdSupplierCategory[0].name : "";
          x.supplier = reqdSupplier.length > 0 ? reqdSupplier[0].name : "";
        });

        setItemDetails((r) => [].concat(data.response.itemDetails));
        gridRef1.current.api.applyTransaction({
          add: data.response.itemDetails,
        });
        setTimeout(() => {
          let pinnedBottomData = generatePinnedBottomData();
          gridRef1.current.api.setPinnedBottomRowData([pinnedBottomData]);
        }, 2000);
      })
      .catch((e) => {
        setAlertTitleText("Oops", "An error occurred");
        setDataReady(true);
        return;
      });
  }

  const generatePinnedBottomData = () => {
    // generate a row-data with null values
    let result = {};

    gridRef1.current.columnApi.getAllGridColumns().forEach((item) => {
      result[item.colId] = null;
    });
    return calculatePinnedBottomData(result);
  };

  const calculatePinnedBottomData = (target) => {
    //console.log(target);
    //**list of columns fo aggregation**
    let columnsWithAggregation = [
      "supplierCategoryId",
      "purchaseQty",
      "stockQty",
      "rate",
      "value",
      "netAmount",
    ];

    columnsWithAggregation.forEach((element) => {
      gridRef1.current.api.forEachNodeAfterFilter((rowNode) => {
        if (element === "supplierCategoryId") {
          target[element] = "Grand Total";
          return;
        }
        if (element === "purchaseQty") {
          target[element] += Number.parseFloat(rowNode.data["purchaseQty"]);
          return;
        }
        if (element === "value") {
          target[element] += Number.parseFloat(rowNode.data["value"]);
          return;
        }
        if (element === "rate") {
          target[element] = 0.0;
        }
        if (rowNode.data[element] || rowNode.data[element] === 0)
          target[element] += Number.parseFloat(
            APIUTILS.Financial(rowNode.data[element])
          );
      });
      if (target[element] && target[element] !== "Grand Total") {
        target[element] = `${APIUTILS.Financial(target[element])}`;
      }

      target["rate"] = APIUTILS.Financial(
        target["value"] / target["purchaseQty"]
      );
    });
    return target;
  };

  const [isGridReady, setIsGridReady] = useState(false);
  useEffect(() => {
    if (isGridReady) {
      supplierCategoryItems
        .filter((x) => false)
        .concat(getSupplierCategories());
      siteCategoryItems.filter((x) => false).concat(getSiteCategories());
      suppliers
        .filter((x) => false)
        .concat(getSuppliers().filter((v) => v.name !== "Opening Stock"));
      sites.filter((x) => false).concat(getSites());
      itemCategories.filter((x) => false).concat(getItemCategories());
      items.filter((x) => false).concat(getItems());
    }
  }, [isGridReady]);
  const [dto, setDTO] = useState({
    id: 0,
    supplierCategoryId: null,
    siteCategoryId: null,
    supplierId: null,
    siteId: null,
    itemCategoryId: null,
    itemId: null,
    isBillable: 2,
    showCredit: false,
    fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  });
  const [groupBy, setGroupBy] = useState("none");

  const supplierCategoryItems = getSupplierCategories();
  const siteCategoryItems = getSiteCategories();
  const suppliers = getSuppliers().filter((v) => v.name !== "Opening Stock");
  const sites = getSites();
  const itemCategories = getItemCategories();
  const items = getItems();

  const supplierCategoryProps = {
    options: supplierCategoryItems,
    getOptionLabel: (option) => option?.name || "",
  };
  const siteCategoryProps = {
    options: siteCategoryItems,
    getOptionLabel: (option) => option?.name || "",
  };

  const supplierProps = {
    options: suppliers,
    getOptionLabel: (option) => option?.name || "",
  };
  const siteProps = {
    options: sites,
    getOptionLabel: (option) => option?.name || "",
  };

  const itemCategoryProps = {
    options: itemCategories,
    getOptionLabel: (option) => option?.name || "",
  };

  const itemProps = {
    options: items,
    getOptionLabel: (option) => option?.name || "",
  };
  const gridRef = useRef();
  // below code is for grid - 1
  const columnDefs1 = [
    {
      flex: 1.5,
      headerName: "Supplier Category",
      field: "supplierCategoryId",
      autoHeight: true,
      wrapText: true,
      valueGetter: (params) => {
        if (params.data.supplierCategoryId === "Grand Total")
          return params.data.supplierCategoryId;

        return supplierCategoryCellRenderer({
          value: params.data.supplierCategoryId,
        });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      flex: 1.8,
      headerName: "Supplier",
      field: "supplierId",
      valueGetter: (params) => {
        return supplierCellRenderer({ value: params.data.supplierId });
      },
      autoHeight: true,
      wrapText: true,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Site Category",
      field: "siteCategory",
      valueGetter: (params) => {
        return customerCategoryCellRenderer({
          value: params.data.siteCategoryId,
        });
      },
      autoHeight: true,
      wrapText: true,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Site",
      field: "siteId",
      valueGetter: (params) => {
        return siteCellRenderer({ value: params.data.customerId });
      },
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "GRN No",
      field: "grnNo",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "GRN Date",
      field: "grnDate",
      filter: false,
      floatingFilter: false,
      valueFormatter: (params) => {
        if (!params.value) return "";
        return dayjs(params.value).format("DD-MM-YYYY");
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      flex: 1.5,
      headerName: "Credit Note",
      field: "creditNote",
      hide: groupBy !== "P",
      autoHeight: true,
      wrapText: true,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Bill No",
      field: "billNo",
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Bill Date",
      field: "billDate",
      filter: false,
      floatingFilter: false,
      valueFormatter: (params) => {
        if (!params.value) return "";
        return dayjs(params.value).format("DD-MM-YYYY");
      },
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      flex: 1.5,
      headerName: "Loading Charges",
      field: "loadingCharges",
      autoHeight: true,
      wrapText: true,
      hide: groupBy !== "P",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      flex: 1.5,
      headerName: "Transport Cost",
      field: "transportCost",
      autoHeight: true,
      wrapText: true,
      hide: groupBy !== "P",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Item Category",
      field: "item",
      autoHeight: true,
      wrapText: true,
      hide: groupBy === "P",
      valueGetter: (params) => {
        return itemCategoryCellRenderer({
          value: params.data.itemCategoryId,
        });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      flex: 1.5,
      headerName: "Item",
      field: "itemId",
      hide: groupBy === "P",
      valueGetter: (params) => {
        return itemCellRenderer({ value: params.data.itemId });
      },
      autoHeight: true,
      wrapText: true,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Purchase Qty",
      field: "purchaseQty",
      hide: groupBy === "P",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Stock Qty",
      field: "stockQty",
      hide: groupBy === "P",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Credit Qty",
      field: "creditQty",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      hide: !dto.showCredit || groupBy === "P",
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Total Cost",
      field: "totalCost",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      hide: !dto.showCredit || groupBy === "P",
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Rate",
      field: "rate",
      hide: groupBy === "P",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Value",
      field: "value",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Net Amount",
      field: "netAmount",
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
  ];
  const gridRef1 = useRef();
  const defaultColDef1 = {
    resizable: true,
    sortable: true,
    editable: false,
    flex: 1,
    filter: "agTextColumnFilter",
    filterParams: {
      caseSensitive: false,
      defaultOption: "startsWith",
    },
    floatingFilter: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };
  const onGridReady1 = (params) => {
    gridRef1.current.api.setRowData([]);

    const p1 = APIMASTER.SupplierCategories()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        console.log("Set supplier category props");
        setSupplierCategories(resp.response);
      });

    const p2 = APIMASTER.SiteCategories()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setSiteCategories(resp.response);
      });

    const p3 = APIMASTER.SupplierOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setSuppliers(resp.response);
      });

    const p4 = APIMASTER.SiteOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setSites(resp.response);
      });

    const p5 = APIMASTER.ItemCategories()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setItemCategories(resp.response);
      });

    const p6 = APIMASTER.ItemOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setItems(resp.response);
      });

    Promise.all([p1, p2, p3, p4, p5, p6]).then(() => {
      setIsGridReady(true);
    });
  };
  const [selectedRowId1, setSelectedRowId1] = useState(0);

  const onRowSelectionChanged1 = (event) => {
    if (event.api.getSelectedRows().length > 0)
      setSelectedRowId1(event.api.getSelectedRows()[0].id);
    else setSelectedRowId1(0);
  };

  const groupByProps = {
    options: [
      { name: "Purchase", value: "P" },
      { name: "Supply", value: "S" },
      { name: "Item", value: "I" },
    ],
    getOptionLabel: (option) => option?.name || "",
  };

  // grid 1 code ends

  const [showCreditDetails, setShowCreditDetails] = useState(false);
  return (
    <SideNav
      currentComponent={MATERIAL_MANAGEMENT_REPORT}
      subComponent={GOODS_RECEIVED_REPORT}
      subComponentPath={PATH_GOODS_RECEIVED_REPORT}
      detailComponent=""
    >
      <div>
        <div style={style}>
          <ThreeCircles
            visible={!dataReady}
            height="256"
            width="256"
            outerCircleColor={SPANISH_GREEN}
            innerCircleColor="#eeeeee"
            middleCircleColor={SPANISH_GREEN}
            ariaLabel="eNirmaan-loading"
            color={SPANISH_GREEN}
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
        <form>
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              marginBottom: 10,
              marginRight: 10,
            }}
          >
            <Button
              style={{
                backgroundColor: SPANISH_GREEN,
                textTransform: "capitalize",
                fontSize: 14,
                color: WHITE,
                minWidth: "180px",
                minHeight: "45px",
                marginRight: 10,
              }}
              onClick={onFormSubmit}
            >
              {GENERATE}
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderColor: SPANISH_GREEN,
              }}
              style={{
                //backgroundColor: SPANISH_GREEN,
                textTransform: "capitalize",
                fontSize: 14,
                color: SPANISH_GREEN,
                minWidth: "180px",
                minHeight: "45px",
                marginRight: 10,
              }}
              onClick={() => {
                let filename = "";
                const sortedItemDetails = getSortedDataFromGrid();
                dto.itemDetails = sortedItemDetails;

                if (dto.isBillable === 2) dto.isBillable = null;
                const payload = { ...dto };
                if (groupBy !== "none") payload.groupBy = groupBy;
                setDataReady(false);
                APIREPORTS.GoodsReceivedReportExport(payload)
                  .then((res) => {
                    setDataReady(true);

                    const contentType = res.headers.get("content-type");
                    if (contentType.startsWith("application/json")) {
                      return Promise.reject(res.json());
                    } else {
                      const header = res.headers.get("Content-Disposition");
                      if (header !== null) {
                        const parts = header.split(";");
                        filename = parts[1].split("=")[1].replaceAll('"', "");
                      } else {
                        filename = "Goods Received Export Report.xlsx";
                      }

                      return res.blob();
                    }
                  })
                  .then((blob) => {
                    if (blob !== null) {
                      let url = window.URL.createObjectURL(blob);
                      let a = document.createElement("a");
                      a.href = url;
                      a.download = filename;
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                    }
                  })
                  .catch((m) => {
                    setAlertTitleText(
                      "Oops...",
                      `Something went wrong...${m.message}`
                    );
                  });
              }}
            >
              {EXPORT}
            </Button>
          </div>
          {/* button div ends */}
          {/* below code is for above container */}
          <div
            style={{
              backgroundColor: LIGHT_GREY_BACKGROUND,
              borderRadius: "5px",
              minWidth: "90%",
              minHeight: "50px",
              padding: 20,
              marginBottom: 10,
              borderStyle: "solid",
              border: "1x",
              borderColor: "#eaeaea",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <table style={{ width: "100%" }}>
              <TableBody>
                <tr>
                  <td>
                    <FormControl
                      variant="standard"
                      sx={{ m: 1, minWidth: 350 }}
                    >
                      <InputLabel>Billability</InputLabel>
                      <Select
                        value={dto.isBillable}
                        name="isBillable"
                        label="Is Billable"
                        onChange={(e) => {
                          setDTO({
                            ...dto,
                            isBillable: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={2}>All</MenuItem>
                        <MenuItem value={1}>Billable</MenuItem>
                        <MenuItem value={0}>Non Billable</MenuItem>
                      </Select>
                    </FormControl>
                  </td>
                  <td>
                    <FormControlLabel
                      name="showCredit"
                      value={dto.showCredit}
                      checked={dto.showCredit}
                      onChange={(e, v) =>
                        setDTO({
                          ...dto,
                          showCredit: e.target.checked,
                        })
                      }
                      control={<Checkbox color="success" />}
                      label="Show Credit Details"
                      style={{ userSelect: "none" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="From Date"
                        inputFormat="DD-MM-YYYY"
                        style={{ minWidth: "272px", minHeight: "48.5px" }}
                        value={dto.fromDate}
                        onChange={(newValue) => {
                          setDTO({
                            ...dto,
                            fromDate: newValue.format("YYYY-MM-DD"),
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            variant="standard"
                            required
                            {...params}
                            style={{
                              minWidth: "350px",
                              minHeight: "48.5px",
                              width: "200px",
                            }}
                            InputLabelProps={{
                              style: { color: "grey", fontSize: 14 },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              style: { fontSize: 14 },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </td>
                  <td>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="To Date"
                        inputFormat="DD-MM-YYYY"
                        style={{ minWidth: "272px", minHeight: "48.5px" }}
                        value={dto.toDate}
                        onChange={(newValue) => {
                          setDTO({
                            ...dto,
                            toDate: newValue.format("YYYY-MM-DD"),
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            variant="standard"
                            required
                            {...params}
                            style={{
                              minWidth: "350px",
                              minHeight: "48.5px",
                              width: "200px",
                            }}
                            InputLabelProps={{
                              style: { color: "grey", fontSize: 14 },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              style: { fontSize: 14 },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </td>
                  <td>
                    <Autocomplete
                      filterOptions={globalFilter}
                      {...supplierCategoryProps}
                      options={supplierCategoryItems}
                      id="auto-complete-1"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="supplierCategoryId"
                      defaultValue={
                        supplierCategoryProps.options.find(
                          (v) => v.value === dto.supplierCategoryId
                        ) || {}
                      }
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, supplierCategoryId: v?.value });
                          else
                            setDTO({
                              ...dto,
                              supplierCategoryId: Number(v?.value),
                            });
                        } else {
                          setDTO({ ...dto, supplierCategoryId: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Supplier Category"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "48.5px",
                            width: "200px",
                            height: "48.5px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey" },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Autocomplete
                      {...supplierProps}
                      options={suppliers}
                      id="auto-complete-2"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="supplierId"
                      defaultValue={
                        supplierProps.options.find(
                          (v) => v.value === dto.supplierId
                        ) || {}
                      }
                      filterOptions={(o, s) => {
                        let options = globalFilter(o, s);
                        let newOptions = [];
                        options.forEach((element) => {
                          if (element.dependentvalue === dto.supplierCategoryId)
                            newOptions.push(element);
                        });
                        return newOptions;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, supplierId: v?.value });
                          else setDTO({ ...dto, supplierId: Number(v?.value) });
                        } else {
                          setDTO({ ...dto, supplierId: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Supplier"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            width: "200px",
                            minHeight: "48.5px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey" },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <Autocomplete
                      filterOptions={globalFilter}
                      {...siteCategoryProps}
                      options={siteCategoryItems}
                      id="auto-complete-3"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="siteCategoryId"
                      defaultValue={
                        siteCategoryProps.options.find(
                          (v) => v.value === dto.siteCategoryId
                        ) || {}
                      }
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, siteCategoryId: v?.value });
                          else
                            setDTO({
                              ...dto,
                              siteCategoryId: Number(v?.value),
                            });
                        } else {
                          setDTO({ ...dto, siteCategoryId: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Site Category"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            width: "200px",
                            minHeight: "48.5px",
                            height: "48.5px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey" },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <Autocomplete
                      {...siteProps}
                      id="auto-complete-4"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="siteId"
                      defaultValue={
                        siteProps.options.find((v) => v.value === dto.siteId) ||
                        {}
                      }
                      filterOptions={(o, s) => {
                        let options = globalFilter(o, s);
                        let newOptions = [];
                        options.forEach((element) => {
                          if (element.dependentvalue === dto.siteCategoryId)
                            newOptions.push(element);
                        });
                        return newOptions;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, siteId: v?.value });
                          else setDTO({ ...dto, siteId: Number(v?.value) });
                        } else {
                          setDTO({ ...dto, siteId: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Site"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "48.5px",
                            width: "200px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* <td>
                    <Autocomplete
                      {...supplierProps}
                      id="auto-complete-5"
                      autoComplete autoHighlight autoSelect
                      includeInputInList
                      name="parentCategory"
                      // isOptionEqualToValue={(o, v) => {
                      //   return o.value === v.value;
                      // }}
                      // filterOptions={(o, s) => {
                      //   let options = globalFilter(o, s);
                      //   let newOptions = [];
                      //   options.forEach((element) => {
                      //     if (element.dependentvalue === dto.supplierCategoryId)
                      //       newOptions.push(element);
                      //   });
                      //   return newOptions;
                      // }}
                      onChange={(e, v) => {}}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Parent Category"
                          variant="standard"
                          style={{
                            minWidth: "200px",
                            minHeight: "48.5px",
                            width: "200px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td> */}
                  <td>
                    <Autocomplete
                      filterOptions={globalFilter}
                      {...itemCategoryProps}
                      id={`autocomplete-6`}
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="itemCategoryId"
                      defaultValue={
                        itemCategoryProps.options.find(
                          (v) => v.value === dto.itemCategoryId
                        ) || {}
                      }
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, itemCategoryId: v?.value });
                          else
                            setDTO({
                              ...dto,
                              itemCategoryId: Number(v?.value),
                            });
                        } else {
                          setDTO({ ...dto, itemCategoryId: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Item Category"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "38.5px",
                            width: "200px",
                            height: "38.5px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <Autocomplete
                      {...itemProps}
                      id={`autocomplete-7`}
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="itemId"
                      defaultValue={itemProps.options.find(
                        (v) => v.value === dto.itemId
                      )}
                      filterOptions={(o, s) => {
                        let options = globalFilter(o, s);
                        let newOptions = [];
                        options.forEach((element) => {
                          if (element.dependentvalue === dto.itemCategoryId)
                            newOptions.push(element);
                        });
                        return newOptions;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, itemId: v?.value });
                          else setDTO({ ...dto, itemId: Number(v?.value) });
                        } else {
                          setDTO({ ...dto, itemId: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Item"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "38.5px",
                            width: "200px",
                            height: "38.5px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <Autocomplete
                      {...groupByProps}
                      id="auto-complete-4"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="groupBy"
                      isOptionEqualToValue={(o, v) => {
                        return o.value === v.value;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          setGroupBy(v.value);
                        } else {
                          setGroupBy("none");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Group By"
                          multiline
                          maxRows={3}
                          variant="standard"
                          style={{
                            minWidth: "350px",
                            minHeight: "48.5px",
                            width: "200px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                </tr>
              </TableBody>
            </table>
          </div>
        </form>
      </div>
      {/* horizontal scroll div */}
      <div
        style={{
          //display:"flex",
          scrollbarWidth: "",
          overflowX: "auto",
          width: "100%",
        }}
      >
        {/* below code is for ag-grid -1 */}
        <div className="App">
          <div
            className="ag-theme-alpine"
            style={{ height: "570px", width: "1800px" }}
          >
            <AgGridReact
              copyGroupHeadersToClipboard={true}
              enableRangeSelection={true}
              columnDefs={columnDefs1}
              ref={gridRef1}
              defaultColDef={defaultColDef1}
              onGridReady={onGridReady1}
              paginationAutoPageSize={true}
              pagination={true}
              onSelectionChanged={onRowSelectionChanged1}
            ></AgGridReact>
          </div>
        </div>
      </div>
    </SideNav>
  );
}
